import { render, staticRenderFns } from "./InsUserGallery.vue?vue&type=template&id=2cd5c4b2&scoped=true&"
import script from "./InsUserGallery.vue?vue&type=script&lang=ts&"
export * from "./InsUserGallery.vue?vue&type=script&lang=ts&"
import style0 from "./InsUserGallery.vue?vue&type=style&index=0&id=2cd5c4b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd5c4b2",
  null
  
)

export default component.exports